import {
    RequestConfigFunction,
} from 'app/types/request.types'

type AirlineLogisticPricingRequests = {
    domainName: string,
    create: RequestConfigFunction<undefined>,
    update: RequestConfigFunction<{id: number}>,
    get: RequestConfigFunction<{id: number}>,
}

const airlineLogisticPricingRequests: AirlineLogisticPricingRequests = {
    domainName: 'airlinelogisticpricing',
    create: () => {
        return {
            url: 'airlinelogisticpricing',
            method: 'POST',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `airlinelogisticpricing/${id}`,
            method: 'PUT',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `airlinelogisticpricing/${id}`,
            method: 'GET',
        }
    },
}

export default airlineLogisticPricingRequests
